import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Form, Button } from 'semantic-ui-react'
import _ from 'lodash';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import queries from '../utils/queries'

const cartaLub = async (list, list2, args, cargar, graphqlFns) => {
  const { allPlantaRtes2, productos, fecha } = graphqlFns;
  let urlSlcmPdf = 'https://montserratslcm.com/api/cartas'

  if (!list || list.length === 0) return;
  document.body.style.cursor = 'wait'
  var QRCode = require('qrcode');

  try {
    const equipos = [];
    const seen = new Set();

    for (const item of list) {
      const clave = `${item.descrPlanta}||${item.descrSeccion}||${item.descrEquipo}`;
      if (!seen.has(clave)) {
        seen.add(clave);
        equipos.push({
          descrPlanta: item.descrPlanta,
          descrSeccion: item.descrSeccion,
          descrEquipo: item.descrEquipo
        });
      }
    }
console.log(equipos)
// if(1>2){
    for (const grupo of equipos) {
      // console.log(`Procesando: ${grupo.descrPlanta} / ${grupo.descrSeccion} / ${grupo.descrEquipo}`);

      let estructuraMec = []
      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${args.descrEmpresa}'`

      let argsBuscarMec = {tipoqry: `[
        {"$unwind": "$secciones"},
        {"$unwind": "$secciones.equipos"},
        {"$unwind": "$secciones.equipos.componentes"},
        {"$unwind": "$secciones.equipos.componentes.mecanismos"},
        {$project: {_id: 1,
          descrEmpresa: 1, descrPlanta: 1, descrSeccion: '$secciones.descrSeccion',
          descrEquipo: '$secciones.equipos.descrEquipo', descrComponente: '$secciones.equipos.componentes.descrComponente',
          descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo'}},
        {$group: {_id: {descrEmpresa: '$descrEmpresa', descrPlanta: '$descrPlanta',descrSeccion: '$descrSeccion',
            descrEquipo: '$descrEquipo', descrComponente: '$descrComponente'}, count: { $sum: 1 }}},
        {$project: {_id: 0, descrEmpresa: "$_id.descrEmpresa", descrPlanta: '$_id.descrPlanta', 
          descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', 
          descrComponente: '$_id.descrComponente', ultInforme: {$toInt: '$count'}}},
          {$match: {${argsBuscar}}}, {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1}}]`}

      if(2>1){
        let {data} = await allPlantaRtes2.refetch(argsBuscarMec)
        estructuraMec = await data.allPlantaRtes
      }


      argsBuscar=""
      argsBuscar += `'descrEmpresa': '${args.descrEmpresa}', 'descrSeccion': {$ne: 'Linea Placa Yeso'}`

      argsBuscar += `, 'descrPlanta': /${grupo.descrPlanta.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}/i`
      argsBuscar += `, 'descrSeccion': /${grupo.descrSeccion.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}/i`
      argsBuscar += `, 'descrEquipo': /${grupo.descrEquipo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}/i`

      let argsBuscarPl = {tipoqry: `[
      {"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
      {$match: {'secciones.equipos.componentes.mecanismos.programacion.puntosLub': {$ne: ""}}},
      {$project: {_id: 1,
        descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
        codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
        codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
        numCarta: '$secciones.equipos.numCarta',
        codComponente: '$secciones.equipos.componentes.codComponente',
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
        consecutivo:{$cond: { 
          if: { $gt: [ '$secciones.equipos.componentes.mecanismos.programacion.consecutivo', '' ] },
            then: {$toInt: '$secciones.equipos.componentes.mecanismos.programacion.consecutivo'}, else: {$toInt: 0}
          }
        },         
        puntosLub: {$toInt: '$secciones.equipos.componentes.mecanismos.programacion.puntosLub'}}},
      {$group: {_id: {descrEmpresa: '$descrEmpresa', descrPlanta: '$descrPlanta', numCarta: '$numCarta', descrSeccion: '$descrSeccion',
          descrEquipo: '$descrEquipo', descrComponente: '$descrComponente', codPlanta: '$codPlanta',
          codSeccion: '$codSeccion', codEquipo: '$codEquipo', codComponente: '$codComponente'},
        cantidadTotal: {$sum: '$puntosLub'}, count: { $sum: 1 }, minutos: {$min: '$consecutivo'}}},
      {$project: {_id: 0, descrEmpresa: "$_id.descrEmpresa",
        codPlanta: '$_id.codPlanta', descrPlanta: '$_id.descrPlanta', numCarta: '$_id.numCarta',
        codSeccion: '$_id.codSeccion', descrSeccion: '$_id.descrSeccion',
        codEquipo: '$_id.codEquipo', descrEquipo: '$_id.descrEquipo',
        codComponente: '$_id.codComponente', descrComponente: '$_id.descrComponente', 
        cantidadTotal: 1, acumUlt: {$toInt: '$count'}, minutos: 1}},
        {$match: {${argsBuscar}}}, {$sort: {descrPlanta: 1, numCarta: 1, minutos: 1}}]`}

        console.log(argsBuscarPl)

      let {data} = await allPlantaRtes2.refetch(argsBuscarPl)
      let estructura = await data.allPlantaRtes
      let allProducto=[]
      if(2>1){
        let { data } = await productos.refetch();
        allProducto = data.allProducto
      }
      document.body.style.cursor = 'default'
      if(estructura.length>0){       
        document.body.style.cursor = 'wait' 
        let response = await fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha

        let rutaArch = '/home//slcm//slcm-client//public//images//procedimientos//'   //Servidor

        let doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})
        // let widthDoc = (doc.internal.pageSize.width)
        let widthDoc = 267.4
        let heightDoc = (doc.internal.pageSize.height)

        doc.setFontSize(10);
        doc.setFontStyle('bold');

        //TABLA DE CONTENIDO
        let tablaRte = [], tablaRte1 = []
        let documento = {}
        let empresa = ""
        let planta = ""
        let seccion = ""
        let equipo = ""
        let totPuntosE = await estructura.filter(elemento => elemento.descrEmpresa===args.descrEmpresa)
        let totPtosEmp = _(totPuntosE)
          .groupBy('descrEmpresa')
          .map((obj, key) => ({
            'descrEmpresa': key,
            'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
            'acumUlt':_.sumBy(obj, 'acumUlt')
          }))
          .value()
          let totMecE = await estructuraMec.filter(elemento => elemento.descrEmpresa===args.descrEmpresa)
          let totMecEmp = _(totMecE)
            .groupBy('descrEmpresa')
            .map((obj, key) => ({
              'descrEmpresa': key,
              'ultInforme':_.sumBy(obj, 'ultInforme')
            }))
            .value()
        for(let ii=0; ii<estructura.length; ii++){
          if(ii===0){
            let totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta)
            let totPtosPl = _(totPuntos)
              .groupBy('descrPlanta')
              .map((obj, key) => ({
                'descrPlanta': key,
                'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                'acumUlt':_.sumBy(obj, 'acumUlt')
              }))
              .value()
            let totMecP = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta)
            let totMecPl = _(totMecP)
              .groupBy('descrPlanta')
              .map((obj, key) => ({
                'descrPlanta': key,
                'ultInforme':_.sumBy(obj, 'ultInforme')
              }))
              .value()

            totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
              elemento.descrSeccion===estructura[ii].descrSeccion)
            let totPtosSe = _(totPuntos)
              .groupBy('descrSeccion')
              .map((obj, key) => ({
                'descrSeccion': key,
                'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                'acumUlt':_.sumBy(obj, 'acumUlt')
              }))
              .value()
              let totMecS = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                elemento.descrSeccion===estructura[ii].descrSeccion)
              let totMecSe = _(totMecS)
                .groupBy('descrSeccion')
                .map((obj, key) => ({
                  'descrSeccion': key,
                  'ultInforme':_.sumBy(obj, 'ultInforme')
                }))
                .value()

            totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
              elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo)
            let totPtosEq = _(totPuntos)
              .groupBy('descrEquipo')
              .map((obj, key) => ({
                'descrEquipo': key,
                'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                'acumUlt':_.sumBy(obj, 'acumUlt')
              }))
              .value()
            let totMecE = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
              elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo)
            let totMecEq = _(totMecE)
              .groupBy('descrEquipo')
              .map((obj, key) => ({
                'descrEquipo': key,
                'ultInforme':_.sumBy(obj, 'ultInforme')
              }))
              .value()

            empresa = estructura[ii].descrEmpresa  
            planta = estructura[ii].descrPlanta
            seccion = estructura[ii].descrSeccion
            equipo = estructura[ii].descrEquipo
            documento = ({columna1: `EMPRESA: ${empresa}`, columna2: totMecEmp[0].ultInforme, columna3: totPtosEmp[0].acumUlt, columna4: totPtosEmp[0].cantidadTotal, columna5: ""})
            tablaRte1.push(documento)
            documento = ({columna1: `PLANTA: ${planta}`, columna2: totMecPl[0].ultInforme, columna3: totPtosPl[0].acumUlt, columna4: totPtosPl[0].cantidadTotal, columna5: ""})
            tablaRte1.push(documento)
            documento = ({columna1: `SECCION: ${seccion}`, columna2: totMecSe[0].ultInforme, columna3: totPtosSe[0].acumUlt, columna4: totPtosSe[0].cantidadTotal, columna5: ""})
            tablaRte1.push(documento)
            let numCarta = ""
            if(estructura[ii].numCarta){
              numCarta = estructura[ii].numCarta.toString()
            }
            documento = ({columna1: `EQUIPO: ${equipo}`, columna2: totMecEq[0].ultInforme, columna3: totPtosEq[0].acumUlt, columna4: totPtosEq[0].cantidadTotal, columna5: numCarta})
            tablaRte1.push(documento)
          }
          if(planta===estructura[ii].descrPlanta&&seccion===estructura[ii].descrSeccion&&equipo===estructura[ii].descrEquipo){
            let numCarta = ""
            if(estructura[ii].numCarta){
              numCarta = estructura[ii].numCarta.toString()
            }
            let totMecComp = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
              elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo
              &&elemento.descrComponente===estructura[ii].descrComponente)
            let totMecCo = _(totMecComp)
              .groupBy('descrComponente')
              .map((obj, key) => ({
                'descrComponente': key,
                'ultInforme':_.sumBy(obj, 'ultInforme')
              }))
              .value()
            documento = ({columna1: `COMPONENTE: ${estructura[ii].codComponente} ${estructura[ii].descrComponente}`, columna2: totMecCo[0].ultInforme, columna3: estructura[ii].acumUlt, columna4: estructura[ii].cantidadTotal, columna5: numCarta})
            tablaRte1.push(documento)
          }else{
            let totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta)
            let totPtosPl = _(totPuntos)
              .groupBy('descrPlanta')
              .map((obj, key) => ({
                'descrPlanta': key,
                'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                'acumUlt':_.sumBy(obj, 'acumUlt')
              }))
              .value()
            let totMec = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta)
            let totMecPl = _(totMec)
              .groupBy('descrPlanta')
              .map((obj, key) => ({
                'descrPlanta': key,
                'ultInforme':_.sumBy(obj, 'ultInforme')
              }))
              .value()

            totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
              elemento.descrSeccion===estructura[ii].descrSeccion)
            let totPtosSe = _(totPuntos)
              .groupBy('descrSeccion')
              .map((obj, key) => ({
                'descrSeccion': key,
                'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                'acumUlt':_.sumBy(obj, 'acumUlt')
              }))
              .value()
            totMec = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                elemento.descrSeccion===estructura[ii].descrSeccion)
            let totMecSe = _(totMec)
              .groupBy('descrSeccion')
              .map((obj, key) => ({
                'descrSeccion': key,
                'ultInforme':_.sumBy(obj, 'ultInforme')
              }))
              .value()  

            totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
              elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo)
            let totPtosEq = _(totPuntos)
              .groupBy('descrEquipo')
              .map((obj, key) => ({
                'descrEquipo': key,
                'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                'acumUlt':_.sumBy(obj, 'acumUlt')
              }))
              .value()
            totMec = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
              elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo)
            let totMecEq = _(totMec)
              .groupBy('descrEquipo')
              .map((obj, key) => ({
                'descrEquipo': key,
                'ultInforme':_.sumBy(obj, 'ultInforme')
              }))
              .value()  

            if(planta!==estructura[ii].descrPlanta){
              planta = estructura[ii].descrPlanta
              documento = ({columna1: `PLANTA: ${planta}`, columna2: totMecPl[0].ultInforme, columna3: totPtosPl[0].acumUlt, columna4: totPtosPl[0].cantidadTotal, columna5: ""})
              tablaRte1.push(documento)
            }
            if(seccion!==estructura[ii].descrSeccion){
              seccion = estructura[ii].descrSeccion
              documento = ({columna1: `SECCION: ${seccion}`, columna2: totMecSe[0].ultInforme, columna3: totPtosSe[0].acumUlt, columna4: totPtosSe[0].cantidadTotal, columna5: ""})
              tablaRte1.push(documento)
            }
            if(equipo!==estructura[ii].descrEquipo){
              equipo = estructura[ii].descrEquipo
              let numCarta = ""
              if(estructura[ii].numCarta){
                numCarta = estructura[ii].numCarta.toString()
              }
              documento = ({columna1: `EQUIPO: ${equipo}`, columna2: totMecEq[0].ultInforme, columna3: totPtosEq[0].acumUlt, columna4: totPtosEq[0].cantidadTotal, columna5: numCarta})
              tablaRte1.push(documento)
            }
            let numCarta = ""
            if(estructura[ii].numCarta){
              numCarta = estructura[ii].numCarta.toString()
            }
            let totMecComp = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
              elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo
              &&elemento.descrComponente===estructura[ii].descrComponente)
            let totMecCo = _(totMecComp)
              .groupBy('descrComponente')
              .map((obj, key) => ({
                'descrComponente': key,
                'ultInforme':_.sumBy(obj, 'ultInforme')
              }))
              .value()
            documento = ({columna1: `COMPONENTE: ${estructura[ii].codComponente} ${estructura[ii].descrComponente}`, columna2: totMecCo[0].ultInforme, columna3: estructura[ii].acumUlt, columna4: estructura[ii].cantidadTotal, columna5: numCarta})

            tablaRte1.push(documento)
          }
        }
        tablaRte1.forEach((elemento3, ii) => {
          let argsUpd = []
          argsUpd.push(elemento3.columna1)
          argsUpd.push(elemento3.columna2)
          argsUpd.push(elemento3.columna3)
          argsUpd.push(elemento3.columna4)
          argsUpd.push(elemento3.columna5)
          tablaRte.push(argsUpd)
        })
        let filaBold =-1

        doc.autoTable({startY: 40,
          tableLineWidth: 0.1,
          styles: {
            fontSize: 9,
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: "white",
            textColor: "black",
            fontSize: 9,
            halign: "center",
          },
          bodyStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            cellWidth: 'auto',
            cellPadding: 1,
          },
          columnStyles: {
            1: {halign: "center"},
            2: {halign: "center"},
            3: {halign: "center"},
            4: {halign: "center"}
          },

          didParseCell(data) {
            if(data.row.index !== -1 && data.section==='head'){
              if(data.cell.raw==='TABLA DE CONTENIDO'){
                data.cell.colSpan = 5
              }
            }
            if(data.row.index !== -1 && data.section==='body'){
              if(data.cell.text[0].substr(0, 6)==='PLANTA'||data.cell.text[0].substr(0, 6)==='SECCIO'||
                  data.cell.text[0].substr(0, 6)==='EQUIPO' || data.cell.text[0].substr(0, 6)==='EMPRES'){
                filaBold = data.row.index
              }
              if(filaBold===data.row.index){
                data.row.cells[data.column.index].styles.fontStyle = 'bold';
              }
            }
          },
          alternateRowStyles: {
            fillColor: "white",
            textColor: "black"
          },
          head: [["TABLA DE CONTENIDO", "", "", "", ""],
                  ["", {content: "CANT. DE MECANISMOS", styles: {halign: "center"}}, {content: "CANT. DE TAREAS DE LUB.", styles: {halign: "center"}}, {content: "PUNTOS LUB. EN TAREAS", styles: {halign: "center"}}, {content: "CARTA No.", styles: {halign: "center"}}]],
          body: tablaRte,
          margin: {top: 40, left: 12, right: 25, bottom: 25}})
        //FIN TABLA DE CONTENIDO
        doc.addPage()
        //MECANISMOS POR COMPONENTE
          for(let ii=0; ii<estructura.length; ii++){
            doc.setFillColor('#E9E4F0');
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'F', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'F', true)
            
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,41, [1,1], 'F', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),41, [1,1], 'F', true)

            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,46, [1,1], 'F', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),46, [1,1], 'F', true)
      
            doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,51, [1,1], 'F', true)

            doc.lines([[(widthDoc/4)-12,0],[0,5],[0-(widthDoc/4)+12,0]], (widthDoc/4)*3,46, [1,1], 'F', true)

            doc.setDrawColor('black');
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'S', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'S', true)
            
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,41, [1,1], 'S', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),41, [1,1], 'S', true)

            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,46, [1,1], 'S', true)
            doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),46, [1,1], 'S', true)

            doc.rect(12, 51, widthDoc-24, 5)   

            doc.lines([[(widthDoc/4)-12,0],[0,5],[0-(widthDoc/4)+12,0]], (widthDoc/4)*3,46, [1,1], 'S', true)

            doc.setFontSize(8);
            doc.setFontStyle('bold');
            doc.text(`PLANTA: ${estructura[ii].descrPlanta}`,14, 40)
            doc.text(`CODIGO: ${estructura[ii].codPlanta}`, (widthDoc/2)+2, 40)
            doc.text(`SECCION: ${estructura[ii].descrSeccion}`,14, 45)
            doc.text(`CODIGO: ${estructura[ii].codSeccion}`, (widthDoc/2)+2, 45)

            doc.text(`EQUIPO: ${estructura[ii].descrEquipo}`,14, 50)
            doc.text(`CODIGO: ${estructura[ii].codEquipo}`, (widthDoc/2)+2, 50)

            let numCarta = ""
            if(estructura[ii].numCarta){
              numCarta = estructura[ii].numCarta.toString()
            }
            doc.text(`No CL ${numCarta}`, widthDoc-50, 50, 'left')
            doc.text(`COMPONENTE: ${estructura[ii].descrComponente} CODIGO: ${estructura[ii].codComponente}`,widthDoc/2, 55, { align: 'center' })

            const mecanismos1 = list.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
              elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo&&
              elemento.puntosLub!=="")
            mecanismos1.forEach((elemento1, iii) => {
              mecanismos1[iii].indice = iii
            })

            tablaRte = []
            let descrComponente = ""
            let modoTarea = ''
            let requiereSISO = ''
            mecanismos1.forEach((elemento1, iii) => {
              if(elemento1.modoTarea){
                modoTarea = elemento1.modoTarea
              } 
              if(elemento1.requiereSISO){
                requiereSISO = elemento1.requiereSISO
              }
              let argsUpd = []
              
              if(descrComponente!==elemento1.descrComponente && iii>0){
                descrComponente = elemento1.descrComponente
                argsUpd.push(`COMPONENTE: ${elemento1.descrComponente} CODIGO: ${elemento1.codComponente}`)
                tablaRte.push(argsUpd)
                argsUpd = []
              }else{
                descrComponente = elemento1.descrComponente
              }
              argsUpd.push(elemento1.descrMecanismo)
              argsUpd.push("")
              argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1.cantidadTotal) + `(${elemento1.abrevUnidad})`)
              argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1.cantidad) + `(${elemento1.abrevUnidad})`)
              argsUpd.push(elemento1.puntosLub)
              argsUpd.push(elemento1.descrFrecuencia)
              argsUpd.push(elemento1.descrMetodo)
              argsUpd.push(`${elemento1.descrTarea} / ${modoTarea} / ${requiereSISO}`)
              // argsUpd.push(elemento1.codProcedimiento)
              argsUpd.push("")
              // if(ficha){
                // argsUpd.push("")
              // }else{
                argsUpd.push(elemento1.descrLubricante)
              // }
              argsUpd.push(elemento1.claseLub)
              argsUpd.push(elemento1.descrGrado)
              argsUpd.push(elemento1.tipoLub)
              argsUpd.push(elemento1.categoriaLub)
              tablaRte.push(argsUpd)
            })
            let descrPlanta = estructura[ii].descrPlanta
            let descrSeccion = estructura[ii].descrSeccion
            let descrEquipo = estructura[ii].descrEquipo

            for(let iii=0; iii<mecanismos1.length+1; iii++){
              if(estructura[ii].descrPlanta===descrPlanta&&estructura[ii].descrSeccion===descrSeccion&&
                estructura[ii].descrEquipo===descrEquipo){
                  if(ii<estructura.length-1 && mecanismos1.length>1){
                    ii += 1
                  }
              }else{
                ii -= 1
                iii=mecanismos1.length
              }
            }
            let indice = 0
            let esComp = false
            doc.autoTable({
              startY: 56,
              rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
              showHead: 'everyPage',
              tableLineColor: "black",
              tableLineWidth: 0.1,
              styles: {
                fontSize: 8,
                lineColor: "black",
                lineWidth: 0.1
              },
              headStyles: {
                fillColor: "#E9E4F0",
                textColor: "black",
                halign: "center",
                cellPadding: 1,
                fontStyle: "bold",
                fontSize: 7
              },
              bodyStyles: {
                fillColor: "white",
                textColor: "black",
                halign: "center",
                minCellHeight: 20
              },
              columnStyles: {
                0: {cellWidth: 28.4},
                1: {cellWidth: 17.7},
                2: {cellWidth: 10.7},
                3: {cellWidth: 10.7},
                4: {cellWidth: 11.7},
                5: {cellWidth: 17.7},
                6: {cellWidth: 14.7},
                7: {cellWidth: 19.7},
                8: {cellWidth: 22.7},
                9: {cellWidth: 23.3},
                10: {cellWidth: 13.7},
                11: {cellWidth: 10.7},
                12: {cellWidth: 10.7},
                13: {cellWidth: 8.7},
                14: {cellWidth: 16.7},
              },

              didParseCell(data) {
                if(data.row.index !== -1 && data.section==='head'){
                  if(data.cell.raw==='MECANISMO'||data.cell.raw==='QR MECANISMO'||
                      data.cell.raw==='ROTULO'){
                    data.cell.rowSpan = 2
                  }
                  if(data.cell.raw==='CANTIDAD DE LUBRICANTE'){
                    data.cell.colSpan = 2
                  }
                  if(data.cell.raw==='LUBRICACION'){
                    data.cell.colSpan = 5
                  }
                  if(data.cell.raw==='LUBRICANTE'){
                    data.cell.colSpan = 5
                  }
                }
                if(data.row.index !== -1 && data.section==='body'){
                  if(data.column.index === 0){
                    esComp = false
                    if(data.cell.text[0].substr(0, 11)==='COMPONENTE:'){
                      esComp = true
                    }
                  }

                  data.cell.styles.minCellHeight = 20
                  data.cell.styles.fillColor = "white"
                  data.cell.styles.fontStyle = "normal"
                  if(esComp){
                    if(data.column.index===0){
                      data.cell.colSpan = 15
                      data.cell.styles.halign = "center"
                      data.cell.styles.fontStyle = "bold"
                    }
                    data.cell.styles.minCellHeight = 7
                    data.cell.styles.fillColor = "#E9E4F0"
                  }

                }
                if(data.row.index !== -1 && data.section==='body' && data.column.index === 9 && !esComp){
                  let ficha = ""

                  let indexLub = allProducto.findIndex( producto => producto.descrLubricante===mecanismos1[indice].descrLubricante)
                  if (indexLub!==-1){
                    if (allProducto[indexLub].ficha==null || allProducto[indexLub].ficha==''){
                    }else{
                      ficha=allProducto[indexLub].ficha
                    }
                  } 

                  if(ficha!==""){
                    data.cell.styles.textColor = "#3366BB"
                  }
                }
              },

              didDrawCell: (data) => {
                if(data.row.index===-1){
                  console.log("ojoooo")
                }

                if(data.row.index !== -1 && data.section==='body' && data.column.index === 0){
                  esComp = false
                  if(data.row.index===0){
                    indice = 0
                  }else{
                    if(data.cell.text[0].substr(0, 11)!=='COMPONENTE:'){
                      indice += 1
                    }else{
                      esComp = true
                    }
                  }
                }

                if(data.row.index !== -1 && data.section==='body' && data.column.index === 14 && !esComp){
                  if(mecanismos1[indice].archRotulo){
                    let imgSourceCB = new Image();
                    imgSourceCB.src = mecanismos1[indice].archRotulo;
                    doc.convertStringToImageData(imgSourceCB)
                    doc.addImage(imgSourceCB, 'PNG', data.cell.x - 1.5, data.cell.y + 2, 40, 20);
                  }
                }

                if(data.row.index !== -1 && data.section==='body' && data.column.index === 1 && !esComp){
                  if(mecanismos1[indice].codigoQR){
                    let canvas = document.createElement("canvas");
                    QRCode.toCanvas(canvas, mecanismos1[indice].codigoQR)
                    let imgSourceQR = canvas.toDataURL("image/svg");
                    doc.addImage(imgSourceQR, 'svg', data.cell.x + 0.5, data.cell.y + 2, 17, 17);
                  }
                }

                if(data.row.index !== -1 && data.section==='body' && data.column.index === 8 && !esComp){
                  if(mecanismos1[indice].codProcedimiento){
                    let urlSlcm = 'https://montserratslcm.com/api/procedimientos/'
                    doc.setTextColor('#3366BB');
                    doc.textWithLink(mecanismos1[indice].codProcedimiento, data.cell.x + 2, data.cell.y + 4, {url: 'https://montserratslcm.com/api/procedimientos/' + mecanismos1[indice].nombreArchivo})
                    doc.setTextColor('black');
                  }
                }
                if(data.row.index !== -1 && data.section==='body' && data.column.index === 9 && !esComp){
                  let ficha = ""
                  // let ficha='PANCARTA ROTULOS DE LUBRICACION.pdf'

                  let indexLub = allProducto.findIndex( producto => producto.descrLubricante===mecanismos1[indice].descrLubricante)
                  if (indexLub!==-1){
                    if (allProducto[indexLub].ficha==null || allProducto[indexLub].ficha==''){
                    }else{
                      ficha=allProducto[indexLub].ficha
                    }
                  } 
                  if(ficha!==""){
                    let urlSlcm = 'https://montserratslcm.com/api/fichas/'
                    doc.link(data.cell.x + 2, data.cell.y + 4, 12.7, 16, { url: urlSlcm + ficha});
                  }
                }
              },
              alternateRowStyles: {
                textColor: "black"
              },
              head: [["MECANISMO", "QR MECANISMO", "CANTIDAD DE LUBRICANTE", "", "LUBRICACION", "", "", "", "", "LUBRICANTE", "", "", "", "", "ROTULO"],
                      ["", "", "TOTAL", "TAREA", "PUNTOS", "FRECUENCIA", "METODO", "TAREA/MODO/SISO", "PROCEDIMIENTO", "DESCRIPCION", "CLASE", "GRADO", "TIPO", "CAT.", ""]],
              body: tablaRte,
              margin: {top: 42.2, left: 12, right: 24, bottom: 25}})
              if(ii<estructura.length){
              //IMAGENES POR EQUIPO
              const estructura1 = await list2.filter(elemento => elemento.descrPlanta===descrPlanta&&
                elemento.descrSeccion===descrSeccion&&elemento.descrEquipo===descrEquipo&&elemento.nombreImagen!==null)

              if(estructura1.length>0||(estructura1.length===0&&ii<estructura.length-1)){
                doc.addPage()
              }
              for(let iiii=0; iiii<estructura1.length; iiii++){            
                const imagenes1 = await list2.filter(elemento => elemento.descrPlanta===estructura1[iiii].descrPlanta&&
                  elemento.descrSeccion===estructura1[iiii].descrSeccion&&elemento.descrEquipo===estructura1[iiii].descrEquipo)

                tablaRte = []
                imagenes1.forEach((elemento1, iii) => {
                  let argsUpd = []
                  argsUpd.push("")
                  tablaRte.push(argsUpd)
                })
                let descrPlanta = estructura1[iiii].descrPlanta
                let descrSeccion = estructura1[iiii].descrSeccion
                let descrEquipo = estructura1[iiii].descrEquipo
                for(let iii=0; iii<imagenes1.length; iii++){
                  if(estructura1[iiii].descrPlanta===descrPlanta&&estructura1[iiii].descrSeccion===descrSeccion&&
                    estructura1[iiii].descrEquipo===descrEquipo){
                      if(iiii<estructura1.length-1){
                        iiii += 1
                      }
                  }else{
                    iiii -= 1
                    iii=imagenes1.length
                  }
                }
                console.log(descrPlanta, descrSeccion, descrEquipo)
                doc.autoTable({
                  startY: 36,
                  rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
                  showHead: 'everyPage',
                  tableLineColor: "black",
                  styles: {
                    fontSize: 8,
                  },
                  headStyles: {
                    fillColor: "#E9E4F0",
                    lineColor: "black",
                    lineWidth: 0.1,
                    textColor: "black",
                    halign: "left",
                    cellPadding: 1,
                    fontStyle: "bold",
                    fontSize: 8
                  },
                  bodyStyles: {
                    halign: "center",
                    minCellHeight: 133
                  },
                  columnStyles: {
                    0: {cellWidth: 25},
                    1: {cellWidth: 93},
                    2: {cellWidth: 81},
                    3: {cellWidth: 41},
                  },

                  didParseCell(data) {
                    if(data.row.index !== -1 && data.section==='head'){
                      if(data.row.index===0){
                        if(data.column.index===0){
                          data.cell.colSpan = 2
                          data.cell.text[0] = "PLANTA: " + imagenes1[0].descrPlanta
                        }
                        if(data.column.index===2){
                          data.cell.colSpan = 2
                          data.cell.styles.halign = "left"
                          data.cell.text[0] = "CODIGO: " + imagenes1[0].codPlanta
                        }
                      }
                      if(data.row.index===1){
                        if(data.column.index===0){
                          data.cell.colSpan = 2
                          data.cell.text[0] = "SECCION: " + imagenes1[0].descrSeccion
                        }
                        if(data.column.index===2){
                          data.cell.colSpan = 2
                          data.cell.text[0] = "CODIGO: " + imagenes1[0].codSeccion
                        }
                      }
                      if(data.row.index===2){
                        if(data.column.index===0){
                          data.cell.colSpan = 2
                          data.cell.text[0] = "EQUIPO: " + imagenes1[0].descrEquipo
                        }
                        if(data.column.index===2){
                          data.cell.text[0] = "CODIGO:" + imagenes1[0].codEquipo
                        }
                        let numCarta = ""
                        if(imagenes1[0].numCarta){
                          numCarta = imagenes1[0].numCarta.toString()
                        }
                        if(data.column.index===3){
                          data.cell.text[0] = "No CL: " + numCarta
                        }
                      }
                    }
                    if(data.row.index !== -1 && data.section==='body'){
                      data.cell.styles.fillColor = "white"
                      if(data.column.index===1){
                        data.cell.colSpan = 4
                      }
                    }
                  },

                  didDrawCell: (data) => {
                    if(data.row.index===-1){
                      console.log("ojoooo")
                    }
                    if(data.row.index !== -1 && data.section==='body' && data.column.index === 1){
                      let imgSourceCB = new Image();
                      let urlSlcm = 'https://montserratslcm.com/api/imgeq/'
                      imgSourceCB.src = urlSlcm + imagenes1[data.row.index].descrEmpresa.replace(/\./g,'') + "/" + imagenes1[data.row.index].nombreImagen;
                      doc.convertStringToImageData(imgSourceCB)

                      let ancho = 200
                      let alto = 133
                      let nuevoAncho = imagenes1[data.row.index].anchoImagen
                      let nuevoAlto = imagenes1[data.row.index].altoImagen
                      if(imagenes1[data.row.index].anchoImagen>imagenes1[data.row.index].altoImagen){
                        nuevoAncho = ancho
                        let porcEscalado = (imagenes1[data.row.index].anchoImagen * 100) / ancho
                        nuevoAlto = (100 * imagenes1[data.row.index].altoImagen) / porcEscalado
                        if(parseInt(nuevoAlto, 10)>133){
                          porcEscalado = (parseInt(nuevoAlto, 10) * 100) / 133
                          nuevoAncho = (100 * 200) / porcEscalado
                          nuevoAlto = 133
                        }
                      }else{
                        nuevoAlto = alto
                        let porcEscalado = (imagenes1[data.row.index].altoImagen * 100) / alto
                        nuevoAncho = (100 * imagenes1[data.row.index].anchoImagen) / porcEscalado
                        if(parseInt(nuevoAncho, 10)>200){
                          porcEscalado = (parseInt(nuevoAncho, 10) * 100) / 200
                          nuevoAlto = (100 * 133) / porcEscalado
                          nuevoAncho = 200
                        }
                      }
                      nuevoAncho = parseInt(nuevoAncho, 10)
                      nuevoAlto = parseInt(nuevoAlto, 10)
                      doc.addImage(imgSourceCB, 'PNG', data.cell.x + ((216 - (nuevoAncho)) / 2), data.cell.y + 2, nuevoAncho, nuevoAlto, undefined, 'FAST');
                    }
                  },
                  head: [["", "", "", ""], ["", "", "", ""], ["", "", "", ""]],
                  body: tablaRte,
                  margin: {top: 42.1, left: 14, right: 14, bottom: 25}})
                
                if(iiii<estructura1.length && ii<estructura.length-1){
                  doc.addPage()
                }
              }
              //FIN IMAGENES POR EQUIPO
            }
          }
          //FIN MECANISMOS POR COMPONENTE

          const pageCount = doc.internal.getNumberOfPages();
          for(var i = 1; i <= pageCount; i++) {
              doc.setPage(i);

    //ENCABEZADO DE PAGINA
              doc.setFontSize(14);
              doc.setFontType("bold");
              doc.text("CARTAS DE LUBRICACION", widthDoc/2, 14, 'center')
              doc.text(list[0].descrEmpresa, widthDoc/2, 24, 'center')
              doc.setFontSize(10);

              let dirSlcm = 'images/logos/LCMSAS.png'

              let miLista = document.getElementById("miLista")
              let dirEmpresa = 'images/logos/' + miLista.options[miLista.selectedIndex].attributes[0].value
              let imgSource = new Image();
              try{
                imgSource.src = dirSlcm;
                doc.convertStringToImageData(imgSource)
                doc.addImage(imgSource, 'PNG', 12, 12, 56, 20);
              }catch{
                console.log("Logo de LCM no existe")
              }

              try{
                imgSource.src = dirEmpresa;
                doc.convertStringToImageData(imgSource)
                if(list[0].descrEmpresa==='CELSIA' || list[0].descrEmpresa==='CELSIA COLOMBIA' || list[0].descrEmpresa==='TRIBOS INGENIERIA SAS' || list[0].descrEmpresa==='URRA S.A .E.S.P' || list[0].descrEmpresa==='BIOENERGY'){
                  doc.addImage(imgSource, 'PNG', widthDoc-49, 10, 25, 25);
                }else{
                  doc.addImage(imgSource, 'PNG', widthDoc-56-12, 12, 50, 20);
                }
              }catch{
                console.log("Logo de la empresa no existe")
              }
    //FIN ENCABEZADO DE PAGINA

              doc.text('Pag ' + String(i) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
              doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
          } 
          document.body.style.cursor = 'default'
        let nameDocEq = `${list[0].descrEmpresa}_${grupo.descrPlanta}_${grupo.descrSeccion}_${grupo.descrEquipo}.pdf`
        if (cargar==='N'){
          doc.save(nameDocEq)
        }else{
            const blob = doc.output('blob');
            const formData = new FormData();
            formData.append('pdf', blob, nameDocEq); 
            try {
                const response = await fetch('https://montserratslcm.com/api/cartas', {
                  method: 'POST',
                  body: formData
                });

              if (!response.ok) {
                throw new Error(`Error al subir: ${response.statusText}`);
              }
              console.log('✅ PDF subido:', nameDocEq);
            } catch (error) {
              console.error('❌ Error al subir PDF:', error.message);
            }
        }
      }
    }
  // }
  } catch (error) {
    console.error('Error en cartaLub:', error);
  }
};
export default cartaLub
